import { GDPR_STATE } from './constants';

export const isGdprCookieBannerVisible = state => state[GDPR_STATE].cookieBanner.visible;
export const getGdprCookieBannerUrl = state => state[GDPR_STATE].cookieBanner.url;
export const isPersonalizedAdsEnabled = state => state[GDPR_STATE].personalizedAds;



// WEBPACK FOOTER //
// ./app/Gdpr/selectors.js